var React = require('react');

function KbdReturn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 8.35c0 .692-.25 1.3-.749 1.825-.499.525-1.103.788-1.813.788H7.419V13.5L0 9.963l7.419-3.567v2.537h5.155c.347 0 .645-.11.893-.329.249-.218.373-.502.373-.85V2.5H16v5.85z"}));
}

KbdReturn.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = KbdReturn;

KbdReturn.default = KbdReturn;
